// extracted by mini-css-extract-plugin
export default {"powerBiFrame":"lQDIonIXL_"};